import { type ServiceMethod } from '@/application/interfaces/service';
import { type ItemId } from '@/infra/services/catalog/model';

import { type Seller } from './model';

export type Params = {
  productId: ItemId;
};

export type Response = {
  data: Seller[];
};

const getSellers: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { productId } = data;

    const { body: response } = await httpClient.get<Response, Params>(
      '/api/v3/products/{productId}/sellers',
      {
        ...options,
        params: {
          productId,
        },
      }
    );

    return response;
  };

export default getSellers;
